import {ArrowUpRight} from '@nlabs/gothamjs/icons';
import {Link} from '@nlabs/gothamjs/router';

import {primaryButton} from '../../theme/classes.js';
import {PublicNavLink} from '../PublicNavLink/PublicNavLink.js';
import {SiteFooter} from '../SiteFooter/SiteFooter.js';

import type {ReactElement, ReactNode} from 'react';

interface PublicShellProps {
  readonly authPage?: boolean;
  readonly children: ReactNode;
  readonly signedIn: boolean;
}
const mark = new URL('../../assets/reactorbox-mark.png', import.meta.url).href;

export const PublicShell = ({authPage = false, children, signedIn}: PublicShellProps): ReactElement => (
  <div className="public-surface relative isolate min-h-dvh font-sans text-white antialiased selection:bg-violet-400/30">
    <a className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 focus:rounded-full focus:bg-violet-600 focus:p-4" href="#public-main">Skip to content</a>
    <header className="relative z-10 mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-5 py-6 sm:px-8">
      <Link aria-label={signedIn ? 'Reactorbox dashboard' : 'Reactorbox home'} className="flex items-center gap-2 font-heading text-xl font-semibold tracking-tight" to={signedIn ? '/projects' : '/'}><img alt="" className="size-8 object-contain" src={mark} />reactorbox</Link>
      <nav aria-label="Main navigation" className="flex flex-wrap items-center gap-4 font-navigation text-sm sm:gap-7">
        <PublicNavLink to="/features">Features</PublicNavLink>
        <PublicNavLink to="/pricing">Pricing</PublicNavLink>
        <PublicNavLink to={signedIn ? '/account' : '/sign-in'}>{signedIn ? 'Account' : 'Sign in'}</PublicNavLink>
        <PublicNavLink activeClassName="ring-2 ring-violet-200 ring-offset-4 ring-offset-[#17151e]" className={`${primaryButton} hidden! sm:inline-flex!`} to={signedIn ? '/projects' : '/sign-up'}>{signedIn ? 'Open studio' : 'Start free'}<ArrowUpRight size={16} /></PublicNavLink>
      </nav>
    </header>
    <>{authPage ? <div id="public-main">{children}</div> : <main id="public-main">{children}</main>}</>
    <SiteFooter signedIn={signedIn} />
  </div>
);
